import * as THREE from 'three';
import Debug from './Utils/Debug';
import Sizes from './Utils/Sizes';
import Time from './Utils/Time';
import Camera from './Camera/Camera';
import Renderer from './Renderer';
import Mouse from './Utils/Mouse';
//@ts-ignore
import World from './World/World';
import Resources from './Utils/Resources';
import sources from './sources';
import Stats from 'stats.js';
import Loading from './Utils/Loading';
import UI from './UI';
let instance = null;
export default class Application {
    constructor() {
        // Singleton
        if (instance) {
            return instance;
        }
        instance = this;
        // Global access
        //@ts-ignore
        // window.Application = this;
        // Setup
        this.debug = new Debug();
        this.sizes = new Sizes();
        this.mouse = new Mouse();
        this.loading = new Loading();
        this.time = new Time();
        this.scene = new THREE.Scene();
        this.cssScene = new THREE.Scene();
        this.overlayScene = new THREE.Scene();
        this.resources = new Resources(sources);
        this.camera = new Camera();
        this.renderer = new Renderer();
        this.camera.createControls();
        this.world = new World();
        this.ui = new UI();
        const urlParams = new URLSearchParams(window.location.search);
        // Admin access control
        // if (!urlParams.has('Ib6jbg9zxN7m3N')) {
        //     this.showBlackScreen();
        //     return;
        // }
        if (urlParams.has('debug')) {
            this.stats = new Stats();
            this.stats.showPanel(0);
            document.body.appendChild(this.stats.dom);
        }
        // Resize event
        this.sizes.on('resize', () => {
            this.resize();
        });
        // Time tick event
        this.time.on('tick', () => {
            this.update();
        });
    }
    resize() {
        this.camera.resize();
        this.renderer.resize();
    }
    update() {
        if (this.stats)
            this.stats.begin();
        this.camera.update();
        this.world.update();
        this.renderer.update();
        if (this.stats)
            this.stats.end();
    }
    destroy() {
        this.sizes.off('resize');
        this.time.off('tick');
        // Traverse the whole scene
        this.scene.traverse((child) => {
            // Test if it's a mesh
            if (child instanceof THREE.Mesh) {
                child.geometry.dispose();
                // Loop through the material properties
                for (const key in child.material) {
                    const value = child.material[key];
                    // Test if there is a dispose function
                    if (value && typeof value.dispose === 'function') {
                        value.dispose();
                    }
                }
            }
        });
        this.renderer.instance.dispose();
        if (this.debug.active)
            this.debug.ui.destroy();
    }
    showBlackScreen() {
        // Hide all existing content
        document.body.style.backgroundColor = '#000000';
        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.overflow = 'hidden';
        // Clear body content
        document.body.innerHTML = '';
        // Create black screen
        const blackScreen = document.createElement('div');
        blackScreen.style.position = 'fixed';
        blackScreen.style.top = '0';
        blackScreen.style.left = '0';
        blackScreen.style.width = '100vw';
        blackScreen.style.height = '100vh';
        blackScreen.style.backgroundColor = '#000000';
        blackScreen.style.zIndex = '9999';
        blackScreen.style.display = 'flex';
        blackScreen.style.justifyContent = 'center';
        blackScreen.style.alignItems = 'center';
        // Create cyberpunk style text
        const textContainer = document.createElement('div');
        textContainer.style.textAlign = 'center';
        textContainer.style.position = 'relative';
        const text = document.createElement('h1');
        text.textContent = 'Coming very soon...';
        text.style.fontFamily = 'monospace';
        text.style.fontSize = '24px';
        text.style.fontWeight = 'normal';
        text.style.color = '#ffffff';
        text.style.textShadow = '0 0 2px rgba(255, 255, 255, 0.5)';
        text.style.letterSpacing = '2px';
        text.style.animation = 'subtle-fade 2s ease-in-out infinite alternate';
        text.style.margin = '0';
        text.style.opacity = '0.8';
        // Add CSS animation
        const style = document.createElement('style');
        style.textContent = `
            @keyframes subtle-fade {
                from {
                    opacity: 0.8;
                }
                to {
                    opacity: 0.4;
                }
            }
        `;
        document.head.appendChild(style);
        // Remove hover effects for simplicity
        text.style.cursor = 'default';
        textContainer.appendChild(text);
        blackScreen.appendChild(textContainer);
        document.body.appendChild(blackScreen);
    }
}
